import { render, staticRenderFns } from "./PT070RankingParts.vue?vue&type=template&id=0fa6a066&"
import script from "./PT070RankingParts.vue?vue&type=script&lang=js&"
export * from "./PT070RankingParts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports